
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $666bc8f27f76152a$exports = {};
/*! js-cookie v3.0.5 | MIT */ (function(global, factory) {
    $666bc8f27f76152a$exports = factory();
})($666bc8f27f76152a$exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});


const $c7e20aca4d420f52$var$cookies = (0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).get();
const $c7e20aca4d420f52$var$template = document.createElement("template");
$c7e20aca4d420f52$var$template.innerHTML = `
    <style>
        .cookie-container{
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background: #333;
            color: white;
            padding: 1rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            z-index: 9999;
            transition: all .2s ease-in-out;
        }
        
        .cookie-container a{
            text-decoration: none;
            color: #4CAF50;
        }
        
        .cookie-container h3{
            margin: 0;
        }
        
        .cookie-container a:hover{
            cursor: pointer;
        }
        
        .cookieButton{
            background: #fff;
            border: none;
            padding: .5rem 1rem;
            border-radius: 4px;
            cursor: pointer;
            font-weight: bold;
        }
    </style>
    <div class="cookie-container">
        <h3>Cookie Consent</h3>
        <div>
            <p>This website uses cookies to ensure you get the best experience on our website. 
            Please read our <span><a href="./privacy.html">privacy policy</a></span> for more information about how we use cookies.</p>
            <button id="cookie-accept" class="cookieButton">Ok</button>
            <button id="cookie-reject-other" class="cookieButton">Reject Non-essential</button>
        </div>
    </div>
`;
class $c7e20aca4d420f52$var$CookieBanner extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        console.log("element is working");
        const shadowRoot = this.attachShadow({
            mode: "closed"
        });
        let clone = $c7e20aca4d420f52$var$template.content.cloneNode(true);
        shadowRoot.append(clone);
        shadowRoot.querySelector("#cookie-accept").addEventListener("click", ()=>{
            console.log("Consent granted");
            this.style.display = "none";
            (0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).set("cookieConsent", "true", {
                sameSite: "strict"
            });
            window.dataLayer = window.dataLayer || [];
            function gtag() {
                dataLayer.push(arguments);
            }
            gtag('js', new Date());
            gtag('config', 'G-138E1FRVRR');
        });
        shadowRoot.querySelector("#cookie-reject-other").addEventListener("click", ()=>{
            console.log("Other Consent rejected");
            this.style.display = "none";
            (0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).set("cookieConsent", "true", {
                sameSite: "strict"
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).set("XConsent", "false", {
                sameSite: "strict"
            });
        });
    }
}
if (!customElements.get("cookie-banner") && !$c7e20aca4d420f52$var$cookies.cookieConsent) customElements.define("cookie-banner", $c7e20aca4d420f52$var$CookieBanner);


//# sourceMappingURL=graftedinshelterv2.b0b4f51e.js.map
